site.formRadioCheckbox = {
	init: function() {
		$( ".radio-checkbox input[type=radio]" ).click(function() {
			$(this).closest('.lmnt').children('label').removeClass('checked');
			$(this).closest('label').addClass('checked');
		});

		var $radioCheckboxFile = $(".radio-checkbox input:file");

		$radioCheckboxFile.closest('.lmnt').append('<div class="filename">Veldu skjal af tölvu</div>');

		$radioCheckboxFile.change(function (){
			var fileName = $(this).val();
			$(".filename").html(fileName.split("\\").pop());
		});

		$(".radio-checkbox label:contains('Heimilisfang')").closest('.elm').addClass('heimilisfang');
	}
};

site.inits.push('site.formRadioCheckbox.init()');